<template>
    <div id="skuInfoSearch">
        <a-modal
            :title="$t('skuSearch.skuSearch')"
            :visible="visible"
                :zIndex="98"
            width="85%"
            @cancel="handleCancel"
            :maskClosable=false>
            
            <template slot="footer">                      
                 <a-button @click="searchSoOrder"  class="mlt" size="small" type="primary" > <a-icon  type="search" />{{ $t('skuSearch.search') }}</a-button>
            </template>


            <a-form :form="form">
                  <a-row>
                    <a-col span="3">
                        <a-form-item class="rightAlign">
                            <b>{{$t('skuSearch.sku')}}</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="7" offset="1">
                        <a-form-item>
                               <div   class="relative">
                                     <a-input
                                             size="small"
                                             :placeholder="$t('skuSearch.sku')"
                                             autocomplete="off"
                                             style="width: 100%"  
                                              v-decorator="['sku']"                                              
                                              />
                                     <a-icon  @click="lookupSearch('sku')" type="search" class="searIputIcon" />
                                 </div>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item  class="rightAlign">
                            <b>{{$t('skuSearch.multipleSku')}}</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="7" offset="1">
                        <a-form-item>
                              <div   class="relative">
                                    <a-input
                                       size="small"
                                       :placeholder="$t('skuSearch.multipleSku')"
                                       autocomplete="off"
                                          v-decorator="['multipleSku']" 
                                       style="width: 100%"/>
                                </div>
                        </a-form-item>
                    </a-col>
                </a-row>

                  <a-row>
                    <a-col span="3">
                        <a-form-item class="rightAlign">
                            <b>{{$t('skuSearch.skuFrom')}}</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="7" offset="1">
                        <a-form-item>
                           <div   class="relative">
                                 <a-input
                                         size="small"
                                         :placeholder="$t('skuSearch.skuFrom')"
                                         autocomplete="off"
                                           v-decorator="['skuFrom']" 
                                         style="width: 100%"    />
                                 <a-icon   @click="lookupSearch('skuFrom')" type="search" class="searIputIcon" />
                             </div>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item  class="rightAlign">
                            <b>{{$t('skuSearch.skuTo')}}</b>
                        </a-form-item>
                    </a-col>
                    <a-col span="7" offset="1">
                        <a-form-item>
                                <div   class="relative">
                                      <a-input
                                              size="small"
                                              :placeholder="$t('skuSearch.skuTo')"
                                              autocomplete="off"
                                                 v-decorator="['skuTo']" 
                                              style="width: 100%"    />
                                              <!-- <a-input-search size="small" style="width: 100%;" v-model="querySkuCode"  /> -->
                                      <a-icon  @click="lookupSearch('skuTo')" type="search" class="searIputIcon" />
                                 </div>          
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>


            <!--SKU查询弹出窗-->
        <pop-sku  ref="querySkuWindow" v-on:checkedSkuCode="checkedSkuCode"></pop-sku >
    </div>
</template>



<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import adjustmentSearch from './adjustAdvanSearch/adjustmentSearch.vue'
    import popSku from './skuSearch.vue'
    export default {
        components:{  
            adjustmentSearch,
            popSku
            
        },
        data(){
            return {
                visible: false,
                form: this.$form.createForm(this),
                actionSelect:[]
                
            }
        },
        created(){
            //  this.show()
        },
       
        methods:{
            handleCancel(){
                this.visible = false
            },
            show(){
               this.form.resetFields();
               this.visible = true
            },
            searchSoOrder(){
               this.form.validateFields((err, values) => {
                    //  ajax.post(api.SEARCHSOBYSKUINFO, values).then(res => {
                    //      console.info(res.data)
                    // if (res.code == 200) {
//                        上传成功后返回字符串 父表请求要带上

                            console.info(values)
                            //    let skuInfo = 
                               this.visible = false
                            let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                            let topMenuActive = sessionStorage.getItem("menuActive")
                            for(let i in topMenu){
                                if(topMenu[i].key == topMenuActive){
                                    // topMenu[i].importUids = res.data
                                      topMenu[i].skuInfo = JSON.stringify(values)
                                }
                            }
                            sessionStorage.setItem("menu", JSON.stringify(topMenu));
                            this.$emit("cancelImport", "init");
                      
//                         上传成功之后 返回数组去move
                        // if(res.data.length == 1){
                        //     if(this.importparams.isMove == 'Move'){
                        //         let paramsData = [];
                        //         let paramsObj = {}
                        //         paramsObj.key = "uid";
                        //         paramsObj.value = res.data[0]
                        //         paramsData.push(paramsObj)
                        //         let edit = {
                        //             params: paramsData,
                        //         }
                        //         this.$refs.moveComs.show('Move',edit)
                        //     }
                        // }else{
                        //     this.$emit("cancelImport", "init");
                        // }
                    // } else{
                    //      this.$customMessage.warning(res.msg, 3);
                    // }
                    
                    
//                     else {
// //                        某些时候上传失败也会返回字符串 父表请求要带上
//                         if(typeof (res.data) == 'string'){
//                             let topMenu = JSON.parse(sessionStorage.getItem("menu"))
//                             let topMenuActive = sessionStorage.getItem("menuActive")
//                             for(let i in topMenu){
//                                 if(topMenu[i].key == topMenuActive){
//                                     topMenu[i].importUids = res.data
//                                 }
//                             }
//                             sessionStorage.setItem("menu", JSON.stringify(topMenu));
//                             this.$emit("cancelImport", "init");
//                         }
//                         this.upErrordataStr = res.msg
//                         if (this.upErrordataStr.indexOf('@excelFileName') > 0){
//                             this.iFexcelFileBtn = true
//                         }else{
//                             this.iFexcelFileBtn = false
//                         }
//                         let data = res.msg
//                         if(data.split('@')){
//                             data = data.split('@')[0]
//                         }
//                          data = data.split('//')
//                          data = Array.from(new Set(data))
//                          this.upErrordata = data
//                          this.upErrorInfo = true
//                     }
    

                
                    });
               
            },
        lookupSearch(fieldName) {           
              let val= this.form.getFieldValue(fieldName)
              this.$refs.querySkuWindow.show(fieldName,val)
            },
        checkedSkuCode(fieldName,val) {
                          this.form.setFieldsValue({ [ fieldName]: val})
               },

        }
    }
</script>



<style>
   
   .rightAlign{
         text-align: right;
   }
</style>